import { Container } from "@/components/container";

export default function CloudMigration() {
  return (
    <div>
      <section className="bg-secondary/50 border-b">
        <Container className="py-12 md:py-16">
          <h1 className="text-3xl md:text-4xl font-semibold">Cloud Migration</h1>
          <p className="mt-3 text-muted-foreground max-w-2xl">
            Plan and execute smooth migrations to AWS, Azure, or GCP with minimal risk and downtime.
          </p>
        </Container>
      </section>
      <Container className="py-12 md:py-16 grid gap-10 md:grid-cols-3">
        <div className="md:col-span-2 space-y-6">
          <Section title="The problem">
            Lift-and-shift without planning causes cost overruns, performance issues, and surprises
            in security and operations.
          </Section>
          <Section title="Our solution">
            Discovery, dependency mapping, migration waves, testing, and cutover—paired with cost
            governance and security baselines.
          </Section>
          <Section title="Expected outcomes">
            • Predictable migration • Right-sized resources • Improved reliability • Clear runbooks
          </Section>
        </div>
        <aside className="space-y-4">
          <h3 className="font-semibold">Deliverables</h3>
          <ul className="text-sm text-muted-foreground space-y-2 list-disc pl-5">
            <li>Migration plan and timeline</li>
            <li>Architecture diagrams</li>
            <li>Security and backups baseline</li>
            <li>Cost estimates and guardrails</li>
            <li>Cutover and rollback runbooks</li>
          </ul>
        </aside>
      </Container>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="space-y-2">
      <h2 className="text-xl font-semibold">{title}</h2>
      <p className="text-muted-foreground leading-relaxed">{children}</p>
    </div>
  );
}
